const exchangeBuffer = (text) => {
    const element = document.createElement('button');
    element.id = 'button-exchange-buffer';
    element.onclick = (e) => {
        console.log('e: ', e);
        const inp = document.createElement('input');
        inp.value = text;
        document.body.appendChild(inp);
        inp.select();

        if (document.execCommand('copy')) {
            console.log('Done!');
        } else {
            console.log('Failed...');
        }

        document.body.removeChild(inp);
    };
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

export default exchangeBuffer;
